import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES, POSTAL_CODE_REGEX } from "constants/validation";

/**
 * Address Schema
 * Represents an address in the affiliate system
 * Base schema is loose to allow loading legacy data.
 */
export const AddressSchema = Yup.object().transform(transformSnakeToCamel).shape({
  addressLine1: Yup.string().nullable(),
  addressLine2: Yup.string().nullable(),
  subDistrict: Yup.string().nullable(),
  district: Yup.string().nullable(),
  province: Yup.string().nullable(),
  postalCode: Yup.string().nullable(),
});

/**
 * Address Validation Schema
 * Strict rules applied only during form submission.
 */
export const AddressValidationSchema = AddressSchema.clone().shape({
  addressLine1: Yup.string().required(ERROR_MESSAGES.ADDRESS_REQUIRED),
  subDistrict: Yup.string().required(ERROR_MESSAGES.SUB_DISTRICT_REQUIRED),
  district: Yup.string().required(ERROR_MESSAGES.DISTRICT_REQUIRED),
  province: Yup.string().required(ERROR_MESSAGES.PROVINCE_REQUIRED),
  postalCode: Yup.string()
    .required(ERROR_MESSAGES.REQUIRED)
    .matches(POSTAL_CODE_REGEX, ERROR_MESSAGES.POSTAL_CODE_FORMAT),
});
